module.exports = __webpack_public_path__ + "static/media/koala logo.3cc12b7b.jpg";